import React from 'react'
import { CampaignTypesValues } from '../../../utils/CampaignTypes/CampaignTypesValues'
import { Select, MenuItem, FormControl, SelectProps, MenuItemProps } from '@mui/material'

type CampaignTypeProps = {
	name: string
	campaignTypes: CampaignTypesValues[]
	selectedType: string
	updateCampaignType: (type: CampaignTypesValues | undefined) => void
	selectProps?: SelectProps
	itemProps?: MenuItemProps
}
export default function CampaignType({
	campaignTypes,
	selectedType,
	updateCampaignType,
	name = '',
	selectProps = {},
	itemProps = {},
}: CampaignTypeProps) {
	const [selected, setSelected] = React.useState<string | number | null>(selectedType)

	const handleChange = (event: any) => {
		const campaignType = campaignTypes.find((type) => type.value === event.target.value)
		setSelected(event.target.value)
		updateCampaignType(campaignType)
	}

	return (
		<FormControl fullWidth>
			<Select value={selected} onChange={handleChange} name={name} {...selectProps}>
				{campaignTypes.map((type) => (
					<MenuItem key={type.value} value={type.value} {...itemProps}>
						{type.label}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	)
}
